// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./plugins/xtk_demo/web_client/stylesheets/xtkItemView.styl
// module id = 6
// module chunks = 0